const actionlocation = 'lyp-module';

export const MODULE_VIEW_EVENT_OPTIONS = {
  actionlocation
};

export const OWNER_LYP_CLICK = {
  name: 'owner.lyp.click',
  data: {
    actionlocation
  }
};


// WEBPACK FOOTER //
// ./src/universal/components/Lyp/events.js